import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';

import {OptionService} from '../../services/option/option.service';
import {triggerDetailPopup, WORD_HELP_POPUP_PADDING} from "../../defines/client.const";


@Component({
  selector: 'app-word-help',
  templateUrl: './word-help.component.html',
  styleUrls: ['./word-help.component.scss'],
  animations: [triggerDetailPopup]
})
export class WordHelpComponent implements OnInit {
  @Output() closePopup: EventEmitter<void>;

  public calculatedHeight: number = window.innerHeight - WORD_HELP_POPUP_PADDING;

  @HostListener('window:resize')
  onResize() {
    this.calculatedHeight = window.innerHeight - WORD_HELP_POPUP_PADDING;
  }

  constructor(
    private optionService: OptionService,
  ) {
    this.closePopup = new EventEmitter<void>();
  }

  ngOnInit(): void {
  }

  onClose(autoPlay: boolean | null = null): void {
    if (autoPlay !== null) {
      this.optionService.autoPlay = autoPlay;
    }
    this.closePopup.emit();
  }
}
